import React, { useContext, useCallback } from "react";
import { View, Text, Image } from "react-native";
import Heading from "../../../components/Heading/index";
import Paragraph from "../../../components/Paragraph/index";
import SolidButton from "../../../components/Buttons/SolidButton/index";
import palette from "../../../styles/palette";
import UserContext from "../../../contexts/UserContext";
import NumbersContext from "../../../contexts/NumbersContext";
import { useHistory } from "react-router-dom";

export default function GetStartedStep() {
  const { getUser } = useContext(UserContext);
  const { getNumbers } = useContext(NumbersContext);
  const history = useHistory();

  const onNext = useCallback(async () => {
    await getUser();
    await getNumbers();
    history.push("/messages");
  }, [getUser, getNumbers, history]);

  return (
    <View
      style={{
        height: 400,
        padding: 24,
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <View style={{ alignItems: "center" }}>
        <Image
          source={require("~/assets/congrats.gif")}
          style={{ height: 75, width: 75 }}
        />
      </View>

      <View>
        <Heading center mb={0} mt={10}>
          You're all set.
        </Heading>
      </View>

      <View style={{ justifyContent: "center", flex: 1 }}>
        <Paragraph center mb={30}>
          We will text a code to the mobile number provided below. Once you
          receive it, use it to verify your number.
        </Paragraph>
      </View>

      <View>
        <SolidButton
          label="Get Started!"
          color={palette.primary}
          onPress={onNext}
        />
      </View>
    </View>
  );
}
